import React, { FunctionComponent } from 'react';
import i18next from 'i18next';

import RegisterForm from 'views/RegisterView/components/RegisterForm';

import { ViewContainer, ViewContent, Title } from 'styles/view';

import { IRegisterViewProps } from './types';
import './i18n';

const RegisterView: FunctionComponent<IRegisterViewProps> = (props: IRegisterViewProps) => {
  const { onSubmit } = props;

  return (
    <ViewContainer data-testid="register-view">
      <ViewContent>
        <Title>{i18next.t<string>('REGISTER_VIEW:TITLE')}</Title>
        <RegisterForm onSubmit={onSubmit} />
      </ViewContent>
    </ViewContainer>
  );
};

export default RegisterView;
